export default __webpack_public_path__ + "static/media/5.47504fb1.png";